import BaseSecure from 'nast-secure'

/**
 *
 */
export default class NastSecure extends BaseSecure {

}
